var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { childContextCallback } from "./blueprint";
export function withContext(childContextTypes, getChildContext) {
    return {
        staticCallback: function (componentClass) {
            componentClass.childContextTypes = __assign({}, componentClass.childContextTypes, childContextTypes);
        },
        instanceCallbacks: [
            childContextCallback(function (childContext, props) { return (__assign({}, childContext, getChildContext(props))); }),
        ],
    };
}
export default withContext;

//# sourceMappingURL=withContext.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/withContext.js
// module id = 70
// module chunks = 0